import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  formatReferenceDateForApi,
  parseReferenceDateInput,
} from "../isf/isfSiteSetupService";

export default function StudyDatePicker({
  value,
  onChange,
  disabled = false,
  minDate = null,
  maxDate = null,
  placeholder = "dd-mm-yyyy",
  inputClassName = "form-control",
}) {
  return (
    <DatePicker
      selected={parseReferenceDateInput(value)}
      onChange={(date) => onChange?.(formatReferenceDateForApi(date))}
      className={inputClassName}
      dateFormat="dd-MM-yyyy"
      placeholderText={placeholder}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      disabled={disabled}
      minDate={minDate}
      maxDate={maxDate}
      isClearable
    />
  );
}
